<template>
	<div class="real-name-auth">
		<div class="auth-container">
			<p class="auth-notice">
				根据国家相关法律规定，寄件需要实名认证
			</p>
			<form class="auth-form" @submit.prevent="handleSubmit">
				<div class="form-item">
					<span class="form-label">真实姓名</span>
					<div class="form-input-wrapper">
						<input type="text" v-model="formData.name" class="form-input" placeholder="请填写姓名"
							@blur="validateField('name')" @input="validateField('name')" />
					</div>
				</div>
				<!-- 姓名错误提示 -->
				<div class="field-error" v-if="errors.name">
					<span class="error-icon">⚠</span>
					<span class="error-text">{{ errors.name }}</span>
				</div>
				<div class="form-item">
					<span class="form-label">身份证号</span>
					<div class="form-input-wrapper">
						<input type="text" v-model="formData.idCard" class="form-input" placeholder="请输入您的身份证号"
							@blur="validateField('idCard')" @input="validateField('idCard')" />
					</div>
				</div>
				<!-- 身份证号错误提示 -->
				<div class="field-error" v-if="errors.idCard">
					<span class="error-icon">⚠</span>
					<span class="error-text">{{ errors.idCard }}</span>
				</div>
				<div class="auth-agreement">
					<p style="color: #FF3333;">
						请确保如上实名姓名与寄件人姓名保持一致，依据《邮件快件实名收寄管理办法》相关规定，姓名不一致不得收寄。
					</p>
					<p>
						请准确填写如上信息，以免影响实名结果。
					</p>
					<div class="info">
						<p>
							当您使用【寄件】服务时，为满足相关法律规定及监管要求、确保用户身份真实性、实现反欺诈、反恐怖主义等风险控制、保障系统和服务安全、国家安全或提供服务之需要，我们将需要收集您的真实身份信息（姓名、身份证号）进行实名认证，并基于第三方阿里云提供的人脸验证服务收集您的人脸验证结果。您通过本页面填写及提供的身份信息属于您的敏感个人信息，该信息仅用于实名认证。您主动点击"继续人脸核验"代表您充分知悉并同意我们基于上述目的处理您的以上敏感个人信息。请准确填写，以免影响身份核验结果。更多详细说明，<span
								class="bold-text">请查阅</span><span class="privacy-link"
								@click="openPrivacyPolicy">《蒲小英隐私政策》</span>，以及我们在身份核验环节中的各项规则提示。
						</p>
					</div>
				</div>
				<button type="submit" class="submit-btn" :disabled="loading">
					{{ loading ? '认证中...' : '继续人脸核验' }}
				</button>
			</form>
			<div v-if="loading" class="loading">认证请求中，请稍候...</div>
			<div v-if="error" class="error-message">{{ error }}</div>
		</div>

		<!-- 隐私政策弹窗 -->
		<div v-if="showPrivacyModal" class="modal-overlay" @click="closePrivacyModal">
			<div class="modal-content" @click.stop>
				<div class="modal-header">
					<h3>{{ privacyTitle }}</h3>
					<span class="close-btn" @click="closePrivacyModal">&times;</span>
				</div>
				<div class="modal-body">
					<div v-if="privacyLoading" class="loading-text">加载中...</div>
					<div v-else-if="privacyError" class="error-text">{{ privacyError }}</div>
					<div v-else v-html="privacyContent" class="privacy-content"></div>
				</div>
				<div class="modal-footer">
					<button class="confirm-btn" @click="closePrivacyModal">确定</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { buildApiUrl } from '../config/api'

	export default {
		name: 'RealNameAuth',
		data() {
			return {
				formData: {
					name: '',
					idCard: ''
				},
				// 错误信息对象
				errors: {
					name: '',
					idCard: ''
				},
				touched: {
					name: false,
					idCard: false
				},
				loading: false,
				error: '',
				showPrivacyModal: false,
				privacyContent: '',
				privacyTitle: '蒲小英隐私政策',
				privacyLoading: false,
				privacyError: '',
				userId: '',
				env: 'prod',
				url: 'https://pxy.puxiaoying.net/',
			};
		},
		computed: {
			// 表单是否有效
			isFormValid() {
				return this.formData.name.trim() !== '' &&
					this.formData.idCard.trim() !== '' &&
					this.validateIdCard(this.formData.idCard) &&
					!this.errors.name &&
					!this.errors.idCard;
			}
		},
		mounted() {
			document.title = '实名认证';
			this.loadCloudAuthScript();
			this.getUserIdFromUrl();
		},
		methods: {
			// 从URL获取userId
			getUserIdFromUrl() {
				const urlParams = new URLSearchParams(window.location.search);
				this.userId = urlParams.get('userId');
				const env = urlParams.get('env')
				if (env) {
					console.log('env 存在，值为：', env)
					this.env = env;
					if (env === 'test') {
						this.url = 'https://pxy.puxiaoying.net/testtest/';
					}
					if (env === 'dev') {
						this.url = 'https://pxy.puxiaoying.net/devdev/';
					}
				} else {
					this.env = 'prod';
					this.url = 'https://pxy.puxiaoying.net/';
				}
				console.log('接收到的userId:', this.userId);
			},
			// 验证单个字段
			validateField(field) {
				this.touched[field] = true;

				if (field === 'name') {
					const name = this.formData.name.trim();
					if (!name) {
						this.errors.name = '请输入姓名';
					} else if (name.length < 2) {
						this.errors.name = '姓名至少2个字符';
					} else if (name.length > 20) {
						this.errors.name = '姓名不能超过20个字符';
					} else {
						this.errors.name = '';
					}
				}
				if (field === 'idCard') {
					const idCard = this.formData.idCard.trim();
					if (!idCard) {
						this.errors.idCard = '请输入身份证号';
					} else if (!this.validateIdCard(idCard)) {
						this.errors.idCard = '请输入正确的18位身份证号码';
					} else {
						this.errors.idCard = '';
					}
				}
			},
			// 身份证号校验（18位）
			validateIdCard(idCard) {
				// 去除空格
				idCard = idCard.trim();
				// 检查长度
				if (idCard.length !== 18) return false;
				// 检查前17位是否为数字
				const regex = /^[1-9]\d{5}(18|19|20)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
				return regex.test(idCard);
			},
			// 提交前验证所有字段
			validateForm() {
				// 标记所有字段为已触碰
				this.touched.name = true;
				this.touched.idCard = true;

				this.validateField('name');
				this.validateField('idCard');

				return !this.errors.name && !this.errors.idCard;
			},
			loadCloudAuthScript() {
				if (window.getMetaInfo) return;
				const script = document.createElement('script');
				script.src = 'https://o.alicdn.com/yd-cloudauth/cloudauth-cdn/jsvm_all.js';
				script.onload = () => {};
				script.onerror = () => {};
				document.head.appendChild(script);
			},
			generateBizId() {
				return 'biz_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
			},
			async handleSubmit() {
				if (!this.validateForm()) {
					// 滚动到第一个错误字段
					const firstErrorField = document.querySelector('.input-error');
					if (firstErrorField) {
						firstErrorField.scrollIntoView({
							behavior: 'smooth',
							block: 'center'
						});
						firstErrorField.focus();
					}
					return;
				}
				this.loading = true;
				this.error = '';
				try {
					await this.loadCloudAuthScript();
					let MetaInfo = window.getMetaInfo();
					const requestData = {
						metaInfo: MetaInfo,
						identityInfo: {
							name: this.formData.name,
							idCard: this.formData.idCard,
							userId: this.userId,
						},
						bizId: this.generateBizId(),
						timestamp: Date.now(),
					};
					console.log(requestData)
					const response = await fetch(buildApiUrl(this.url, 'prod-api/business/api/faceVerify/init'), {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify(requestData),
					});
					const data = await response.json();
					if (data.success) {
						window.location.href = data.certifyUrl;
					} else {
						this.error = '认证请求失败: ' + (data.message || '未知错误');
					}
				} catch (error) {
					console.error('请求错误:', error);
					this.error = '网络请求失败，请重试';
				} finally {
					this.loading = false;
				}
			},
			async openPrivacyPolicy() {
				this.showPrivacyModal = true;
				this.privacyLoading = true;
				this.privacyError = '';

				try {
					const response = await fetch(buildApiUrl(this.url, 'prod-api/business/htmlPage/cabinet-privacy-policy'), {
						method: 'GET',
						headers: {
							'Content-Type': 'application/json'
						}
					});

					if (response.ok) {
						const result = await response.json();
						console.log('隐私政策返回数据:', result);

						// 根据后端返回的数据结构处理
						if (result.code === 200 && result.data) {
							this.privacyTitle = result.data.title || '蒲小英隐私政策';
							this.privacyContent = result.data.content || '';
						} else {
							this.privacyError = result.msg || '获取隐私政策失败';
						}
					} else {
						this.privacyError = '请求失败，请稍后重试';
					}
				} catch (error) {
					console.error('获取隐私政策失败:', error);
					this.privacyError = '网络请求失败，请检查网络连接';
				} finally {
					this.privacyLoading = false;
				}
			},
			closePrivacyModal() {
				this.showPrivacyModal = false;
				this.privacyContent = '';
				this.privacyError = '';
				this.privacyTitle = '蒲小英隐私政策';
			},
		}
	};
</script>
<style scoped>
	.real-name-auth {
		padding: 20px;
	}

	.auth-container {
		max-width: 400px;
		margin: 0 auto;
		padding: 30px;
		border-radius: 10px;
	}

	.auth-notice {
		color: #ff9900;
		font-size: 14px;
		margin-bottom: 20px;
		text-align: left;
	}

	.auth-form {
		display: flex;
		flex-direction: column;
	}

	.form-item {
		display: flex;
		align-items: center;
		margin-bottom: 20px;
		border: 1px solid #ddd;
		border-radius: 5px;
		overflow: hidden;
	}

	.form-label {
		display: flex;
		align-items: center;
		color: #333;
		width: 80px;
		padding: 0 10px;
		position: relative;
		justify-content: center;
	}

	.form-label::after {
		content: '';
		position: absolute;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
		height: 60%;
		width: 1px;
		background-color: #ddd;
	}

	.form-input-wrapper {
		flex: 1;
	}

	.form-input {
		width: 100%;
		padding: 12px;
		border: none;
		font-size: 16px;
		box-sizing: border-box;
	}

	.form-input:focus {
		outline: none;
	}

	.auth-agreement {
		font-size: 12px;
		color: #666;
		margin-bottom: 20px;
		text-align: left;
	}

	.auth-agreement p {
		margin-bottom: 10px;
		line-height: 1.5;
	}

	.bold-text {
		font-weight: bold;
		color: #333;
	}

	.privacy-link {
		color: #1890ff;
		cursor: pointer;
	}

	.privacy-link:hover {
		color: #40a9ff;
	}

	.submit-btn {
		width: 100%;
		padding: 12px;
		background-color: #699257;
		color: white;
		border: none;
		border-radius: 5px;
		font-size: 16px;
		cursor: pointer;
		transition: background-color 0.3s;
	}

	.submit-btn:hover:not(:disabled) {
		background-color: #5a8150;
	}

	.submit-btn:disabled {
		background-color: #cccccc;
		cursor: not-allowed;
	}

	.loading {
		color: #699257;
		margin-top: 15px;
		font-size: 14px;
		text-align: left;
	}

	.error-message {
		color: #ff4444;
		margin-top: 15px;
		font-size: 14px;
		padding: 10px;
		background-color: #ffeaea;
		border-radius: 5px;
		text-align: left;
	}

	/* 隐私政策弹窗样式 */
	.modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 1000;
	}

	.modal-content {
		background: white;
		border-radius: 10px;
		width: 90%;
		max-width: 600px;
		max-height: 80vh;
		display: flex;
		flex-direction: column;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
	}

	.modal-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 20px;
		border-bottom: 1px solid #eee;
	}

	.modal-header h3 {
		margin: 0;
		color: #333;
		font-size: 18px;
	}

	.close-btn {
		font-size: 24px;
		color: #999;
		cursor: pointer;
		line-height: 1;
	}

	.close-btn:hover {
		color: #666;
	}

	.modal-body {
		flex: 1;
		padding: 20px;
		overflow-y: auto;
	}

	.modal-footer {
		padding: 20px;
		border-top: 1px solid #eee;
		text-align: right;
	}

	.confirm-btn {
		padding: 8px 20px;
		background-color: #699257;
		color: white;
		border: none;
		border-radius: 5px;
		cursor: pointer;
		font-size: 14px;
	}

	.confirm-btn:hover {
		background-color: #5a8150;
	}

	.loading-text {
		text-align: center;
		color: #666;
		padding: 20px;
	}

	.error-text {
		color: #ff4444;
		text-align: center;
		padding: 20px;
	}

	.privacy-content {
		line-height: 1.6;
		color: #333;
		font-size: 14px;
		text-align: left !important;
	}

	.privacy-content ::v-deep * {
		text-align: left !important;
	}

	.privacy-content ::v-deep h1,
	.privacy-content ::v-deep h2,
	.privacy-content ::v-deep h3,
	.privacy-content ::v-deep h4,
	.privacy-content ::v-deep h5,
	.privacy-content ::v-deep h6 {
		color: #333;
		margin-top: 20px;
		margin-bottom: 10px;
		text-align: left !important;
	}

	.privacy-content ::v-deep p {
		margin-bottom: 10px;
		text-align: left !important;
	}

	.privacy-content ::v-deep ul {
		margin-bottom: 10px;
		padding-left: 20px;
		text-align: left !important;
	}

	.privacy-content ::v-deep li {
		text-align: left !important;
	}

	/* 覆盖富文本编辑器的居中样式 */
	.privacy-content ::v-deep .ql-align-center {
		text-align: left !important;
	}

	.privacy-content ::v-deep .ql-align-right {
		text-align: left !important;
	}

	.privacy-content ::v-deep .ql-align-left {
		text-align: left !important;
	}

	/* 响应式设计 */
	@media (max-width: 480px) {
		.real-name-auth {
			padding: 10px;
		}

		.auth-container {
			padding: 20px;
		}

		.form-label {
			width: 70px;
			padding: 0 8px;
			font-size: 14px;
		}

		.modal-content {
			width: 95%;
			margin: 10px;
		}

		.privacy-content {
			font-size: 12px;
		}
	}

	/* 响应式设计 */
	@media (max-width: 480px) {
		.real-name-auth {
			padding: 10px;
		}

		.auth-container {
			padding: 20px;
		}

		.form-label {
			width: 70px;
			padding: 0 8px;
			font-size: 14px;
		}

		.modal-content {
			width: 95%;
			margin: 10px;
		}

		.privacy-content {
			font-size: 12px;
		}
	}

	/* 字段错误提示 */
	.field-error {
		display: flex;
		align-items: center;
		padding: 5px 10px;
		margin-top: -8px;
		margin-bottom: 12px;
		color: #ff4444;
		font-size: 13px;
		animation: slideDown 0.3s ease;
	}

	.field-error .error-icon {
		margin-right: 4px;
		font-size: 14px;
	}

	.field-error .error-text {
		line-height: 1.4;
		padding: 0;
	}
</style>
